var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.data),function(t,index){return _c('li',{key:index},[_vm._t("default",function(){return [_vm._v(_vm._s(t.label))]}),(index !== _vm.data.length - 1)?_c('i',{staticClass:"fas fa-chevron-right"}):_vm._e()],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }